const runForEach = (data, lambda) => {
  if (!data) {
    return;
  } else if (Array.isArray(data)) {
    data.forEach(lambda);
  } else {
    lambda(data);
  }
};

export { runForEach };
